export default "__VITE_ASSET__EAT6YTQK__"